module.exports = __webpack_public_path__ + "img/sticker-valentines.ac26e7a7.png";